import { render, staticRenderFns } from "./CommandMenu.vue?vue&type=template&id=5edb3ba1&"
import script from "./CommandMenu.vue?vue&type=script&lang=js&"
export * from "./CommandMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports